import { createFileRoute } from "@tanstack/react-router";
import { QuoteEditor } from "@/components/QuoteEditor";

export const Route = createFileRoute("/_authenticated/predracun/uredi/$id")({
  head: () => ({ meta: [{ title: "Uredi predračun — kupish.si" }] }),
  component: function Page() {
    const { id } = Route.useParams();
    return <QuoteEditor quoteId={id} />;
  },
});
